// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var ConversationParticipantsDisplay = require("./ConversationParticipantsDisplay.bs.js");
var ConversationsListItemParticipants_conversation_graphql = require("../../../__generated__/ConversationsListItemParticipants_conversation_graphql.bs.js");

var convertFragment = ConversationsListItemParticipants_conversation_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationsListItemParticipants_conversation_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationsListItemParticipants_conversation_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ConversationsListItemParticipants_conversation_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationsListItemParticipants_conversation_graphql.node, convertFragment, fRef);
}

var ConversationFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ConversationsListItemParticipants(props) {
  var conversation = use(props.conversation);
  var match = conversation.conversationListParticipants;
  if (match !== undefined) {
    return JsxRuntime.jsx(ConversationParticipantsDisplay.make, {
                participantsConnection: match.fragmentRefs,
                showNames: props.showNames
              });
  } else {
    return null;
  }
}

var make = ConversationsListItemParticipants;

exports.ConversationFragment = ConversationFragment;
exports.make = make;
/* react/jsx-runtime Not a pure module */
